export default __webpack_public_path__ + "static/media/north.222c1fde.svg";